module.exports = __webpack_public_path__ + "static/media/aflac-choice-large.274b0f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/aflac-choice-large.png
// module id = 7895
// module chunks = 13